<template>
    <section>
        <ul id="comment-hisotry">
            <li v-for="comment in comment_list" @click="select(comment.thread_id, $event)">
                <div class="created_at">{{ comment.date }}</div>
                <div class="comment-content">{{ comment.content }}</div>
            </li>
        </ul>
    </section>
</template>

<script>
    export default {
        name: "comment-history",
        props: [],
        mounted() {
            this.getCommentHistory();
        },
        data: function () {
            return {
                comment_list: [],
            }
        },
        methods: {
            select: function (s, event) {
                if (s) {
                    const id = String(s);
                    location.href = `/thread/detail?thread_id=${id}`;
                }
            },
            getCommentHistory: function () {
                axios.default
                    .get('/comment/history/list')
                    .then(response => {
                        if(this.comment_list.length == 0) {
                            this.comment_list = response.data;
                        } else {
                            this.comment_list = this.comment_list.concat(response.data);
                        }
                    });
            }
        }
    }
</script>

<style scoped>

</style>
